import React from "react";
import CustomSelect from "./CustomSelect";
import ServiceListBox from "./ServiceListBox";

export function ClientSelectSuministroElectrico({
  services,
  selected,
  setSelected,
}) {
  if (!services) return (
    <div className="CustomSelect cursor-default">
      <div className="servicio-list-box text-align-left">
        Cargando servicios...
      </div>
    </div>
  )

  return services.length > 1 ? (
    <CustomSelect
      options={services ? services : []}
      selected={selected}
      placeholder="Selecciona Cliente"
      onClick={(option) => {
        setSelected(option);
      }}
      onChange={(option) => {
        setSelected(option);
      }}
      renderSelected={(option, opened) => {
        return (
          <ServiceListBox
            displayNumberLabel={"abastible_contract_id"}
            clientCodeLabel={"contrato"}
            service={option}
            onlyHeader={false}
          />
        );
      }}
      renderOption={(option, i) => {
        return (
          <ServiceListBox
            displayNumberLabel={"abastible_contract_id"}
            clientCodeLabel={"contrato"}
            service={option}
            hideClientCode={false /* (!selected || !selected.pivot) */}
          />
        );
      }}
    />
  ) : (
    <div className="CustomSelect cursor-default">
      <div className="CustomSelect-icon"></div>
      <div className="servicio-list-box text-align-left">
        <h1 className="font-15">
          N° de contrato {Number(selected["abastible_contract_id"]).toString()}
        </h1>
        {selected.pivot && selected.pivot.company_name ? (
          <p className="uppercase font-14 fw700 lh-100pct margin-top-10">
            {selected.pivot.company_name}
          </p>
        ) : null}
        {selected.pivot && selected.pivot.company_dni ? (
          <p className="uppercase font-14 fw700 lh-130pct">
            RUT: {selected.pivot.company_dni}
          </p>
        ) : null}
      </div>
    </div>
  );
}
